import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/documentTemplates";

const getDocumentTags = () => request(`api/documents/getDocumentTags`, { method: "GET" });

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, orderBy: "id desc" });
    return request(
        `${resource}/getList?withDeleted=true&${query.substring(1)}`,
        { method: "GET" },
        { countInHeaders: true },
    );
};
const list = ({ counterpartyId, ...params }: { counterpartyId: number }) => {
    const query = containsQuery(params, {
        filter: { or: [{ not: { counterparties: { any: [] } } }, { counterparties: { any: { id: counterpartyId } } }] },
    });
    return request(`${resource}/getList${query}`, { method: "GET" });
};

const apply = (params: {}) => alertRequest(`${resource}/apply`, params);
const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));
const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));
const getItem = ({ id }: { id: string }) => request(`${resource}/get/${id}`, { method: "GET" });

export { apply, delItem, index, getItem, restore, getDocumentTags, list };
